var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRvrSafetyAirbags4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 251,
    viewBox: "0 0 382 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7802_660)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.744 83.7429L370.281 88.2254C383.754 96.7899 378.295 118.126 378.295 118.126C367.952 156.916 336.174 221.45 328.561 236.651C327.609 238.529 325.631 239.481 323.552 239.23C309.679 237.577 289.77 248.32 289.77 248.32C285.138 249.598 281.632 243.713 281.632 243.713C279.203 238.329 276.849 233.571 274.595 229.389C262.374 206.851 252.883 200.765 252.883 200.765C252.558 200.39 252.232 199.989 251.932 199.613C234.678 178.703 236.581 161.9 236.581 161.9C237.332 156.616 239.786 151.056 242.967 145.772C247.925 137.559 254.661 130.021 259.469 125.063C263 121.456 265.505 119.228 265.505 119.228C273.017 111.715 277.825 100.296 277.825 100.296C284.286 83.3172 300.288 76.8563 300.288 76.8563C311.457 72.9497 317.492 71.1967 320.497 70.4204",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 9.11701C354.354 8.94171 353.753 8.79146 353.152 8.66625C347.542 7.66456 342.283 6.88825 338.677 6.3874C334.746 5.83647 330.689 7.06354 327.834 9.81819C316.415 21.0371 313.76 44.7521 313.76 44.7521C313.159 54.6438 313.284 60.3785 313.635 63.684C313.86 66.2133 315.488 68.392 317.842 69.3436C318.719 69.7192 319.62 70.0698 320.497 70.4454C331.39 75.0282 342.258 80.5124 342.258 80.5124C342.584 80.7128 342.934 80.8881 343.235 81.0383C348.419 83.8681 351.649 83.7429 351.649 83.7429H366.95C373.561 83.7429 373.286 73.3754 373.286 73.3754C373.286 49.2848 368.878 30.3027 365.673 19.7349C364.095 14.5762 360.063 10.6446 354.955 9.11701H354.93Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.604 10.3691C341.406 15.5529 343.285 63.6841 343.285 63.6841C343.285 73.9263 343.936 79.1351 346.866 80.838",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.604 91.7566C356.958 113.218 344.762 130.622 344.762 130.622C313.534 161.85 282.582 201.341 282.582 201.341C271.914 216.317 276.121 228.813 276.121 228.813",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.114 217.894C315.012 188.995 332.842 165.681 332.842 165.681C341.933 154.262 353.227 153.786 358.911 154.462C360.789 154.663 361.866 156.716 361.065 158.444C344.462 194.38 332.842 219.297 327.934 229.864C326.206 233.496 322.475 235.724 318.468 235.599C313.66 235.424 309.478 234.898 306.072 234.297C300.588 233.295 297.357 227.485 299.311 222.277C300.312 219.572 301.139 217.894 301.139 217.894H301.114Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.568 232.268C314.486 232.143 310.48 231.692 306.673 230.991C305.07 230.691 303.643 229.714 302.842 228.237C301.99 226.784 301.84 225.031 302.441 223.454C303.343 220.949 304.094 219.447 304.119 219.372C317.717 191.074 335.296 167.935 335.497 167.735C342.158 159.396 350.121 157.593 355.606 157.593C356.382 157.593 357.083 157.618 357.734 157.693C341.257 193.253 329.787 217.944 324.904 228.462C323.827 230.791 321.448 232.268 318.819 232.268H318.593H318.568Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.907 199.639C221.706 196.584 209.46 189.121 209.46 189.121C182.89 176.525 159.175 178.378 146.779 184.363C142.322 186.517 139.342 189.221 138.19 191.951",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7802_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: -1,
    width: 283,
    height: 252
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M382 -1H99.874V251H382V-1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7802_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.214 191.951C123.89 188.269 121.787 206.225 121.787 206.225C117.029 238.654 125.994 264.498 125.994 264.498C129.099 273.588 135.961 276.418 135.961 276.418C138.039 288.614 155.769 288.614 155.769 288.614",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.965 145.773C235.052 146.624 226.187 151.357 226.187 151.357C223.282 152.158 221.129 148.502 221.129 148.502C219.601 145.172 218.174 142.242 216.746 139.637C209.133 125.614 203.274 121.857 203.274 121.857C203.073 121.607 202.873 121.382 202.673 121.156C192.005 108.159 193.182 97.7417 193.182 97.7417C194.834 85.6463 211.087 71.272 211.087 71.272C215.77 66.6142 218.775 59.5272 218.775 59.5272C222.781 48.9844 232.673 44.9777 232.673 44.9777C239.585 42.5987 243.316 41.4718 245.194 40.996",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.463 49.2593L276.146 52.064C284.536 57.3479 281.13 70.5953 281.13 70.5953C276.948 86.2967 267.131 108.76 259.468 125.087",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M266.606 2.95624C266.23 2.85607 265.854 2.7559 265.504 2.68077C262.023 2.02967 258.767 1.57891 256.539 1.25336C254.084 0.902773 251.58 1.65404 249.802 3.38195C242.69 10.3437 241.087 25.0435 241.087 25.0435C240.712 31.2039 240.787 34.7849 240.987 36.7883C241.163 38.366 242.139 39.7182 243.617 40.3193C244.143 40.5196 244.694 40.77 245.244 40.9954C251.981 43.8252 258.742 47.256 258.742 47.256C259.644 47.7818 260.495 48.2076 261.221 48.458C263.35 49.3094 264.602 49.2343 264.602 49.2343H274.068C278.175 49.2343 278 42.7984 278 42.7984C278 27.8482 275.245 16.0533 273.292 9.5173C272.315 6.28685 269.786 3.83271 266.631 2.90615L266.606 2.95624Z",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M266.405 3.73328C258.217 6.96372 259.394 36.8141 259.394 36.8141C259.394 43.1748 259.769 46.4052 261.622 47.457",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266.406 54.2177C267.883 67.5401 260.32 78.3333 260.32 78.3333C240.963 97.7411 221.755 122.207 221.755 122.207C215.495 131.022 217.473 138.41 217.723 139.211C217.749 139.236 217.749 139.286 217.749 139.286",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.673 121.155C183.941 119.227 176.379 114.619 176.379 114.619C153.991 104.001 134.859 109.936 132.154 116.372C123.264 114.118 121.962 125.262 121.962 125.262C119.007 145.371 124.591 161.398 124.591 161.398C126.519 167.058 130.752 168.761 130.752 168.761C132.079 176.348 143.047 176.348 143.047 176.348",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M349.921 157.493L351.548 158.094L318.568 229.163L311.756 225.132",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7802_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: -1,
    width: 283,
    height: 252
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382 -1H99.874V251H382V-1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7802_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.716 166.532C334.47 155.639 329.837 139.211 329.337 129.695C328.986 123.334 325.856 117.474 320.797 113.643L308.326 104.152C302.541 99.7444 294.929 98.4923 288.042 100.871L259.118 110.813C252.056 113.242 246.672 119.077 244.844 126.314L235.278 197.534C230.695 239.28 288.843 256.509 305.396 223.829C315.563 203.745 324.804 212.86 324.804 212.86",
    fill: "#727272"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M346.716 166.533C334.47 155.639 329.837 139.212 329.337 129.695C328.986 123.335 325.856 117.475 320.797 113.618L308.326 104.127C302.541 99.7199 294.929 98.4678 288.042 100.847L259.118 110.789C252.056 113.218 246.672 119.053 244.844 126.29L235.278 197.51C230.695 239.255 288.843 256.484 305.396 223.804C315.563 203.72 324.804 212.836 324.804 212.836",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.505 106.757C304.795 102.399 297.257 101.172 290.471 103.526L261.898 113.343C254.911 115.747 249.627 121.507 247.799 128.669L238.358 198.987C236.705 214.063 242.515 225.757 251.38 232.92",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.186 151.633C331.69 181.684 316.239 206.3 316.239 206.3",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M195.186 17.5564C191.204 14.5263 185.97 13.6749 181.237 15.3026L161.354 22.1391C156.496 23.817 152.814 27.8237 151.537 32.8071L144.976 81.7397C143.824 92.2324 147.881 100.371 154.042 105.354",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M218.775 59.552C218.775 59.552 215.795 66.639 211.112 71.2968C211.112 71.2968 206.855 75.0532 202.447 80.3621C198.791 84.7946 195.035 90.3039 193.632 95.5628C192.981 96.5394 192.305 97.6913 191.629 99.0436C180.109 121.782 139.641 109.787 142.822 80.7377L149.483 31.1792C150.76 26.1457 154.491 22.0888 159.425 20.386L179.558 13.4743C184.342 11.8215 189.651 12.673 193.682 15.7531L202.347 22.3643C205.853 25.0438 208.032 29.1257 208.282 33.5331C208.607 39.8939 211.613 50.662 219.351 58.1997C219.15 58.6255 218.95 59.0762 218.775 59.552Z",
    fill: "#727272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.351 58.1997C211.613 50.662 208.607 39.8939 208.282 33.5331C208.032 29.1257 205.853 25.0438 202.347 22.3643L193.682 15.7531C189.651 12.673 184.342 11.8215 179.558 13.4743L159.425 20.386C154.491 22.0888 150.76 26.1457 149.483 31.1792L142.822 80.7377C139.641 109.787 180.109 121.782 191.629 99.0436C192.305 97.6913 192.981 96.5394 193.632 95.5628",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.182 48.7836C209.284 61.8807 205.452 73.5003 202.447 80.3618",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193.183 97.7668C193.283 97.0406 193.433 96.3144 193.633 95.5631C195.036 90.3042 198.792 84.7949 202.448 80.3625C206.856 75.0535 211.113 71.2972 211.113 71.2972C215.796 66.6393 218.776 59.5524 218.776 59.5524C218.951 59.0766 219.151 58.6258 219.352 58.2001",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.583 73.703L78.8728 87.1393C77.6774 87.3872 76.8805 88.6763 77.1019 90.0398C77.3011 91.2297 78.2309 92.0726 79.2713 92.0726C79.4041 92.0726 79.5369 92.0726 79.6919 92.023L141.41 78.9833",
    fill: "#727272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.52 79.1606L171.044 73.6263C171.896 74.5028 173.073 75.0787 174.4 75.0787C176.954 75.0787 179.033 73.0002 179.033 70.4459C179.033 67.8916 176.954 65.8131 174.4 65.8131C172.472 65.8131 170.794 67.0151 170.118 68.693L142.872 73.8266",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.167 140.311L78.3419 87.2845C77.0664 86.8818 75.7188 87.6117 75.3337 88.9455C74.9487 90.2793 75.6466 91.6887 76.922 92.0914L240.565 145.344",
    fill: "#727272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.787 145.221L280.979 157.843C281.53 159.796 283.308 161.248 285.437 161.248C287.991 161.248 290.07 159.17 290.07 156.615C290.07 154.061 287.991 151.983 285.437 151.983C284.31 151.983 283.283 152.408 282.482 153.059L241.413 140.188",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.503 70.4202C176.503 71.5972 175.552 72.5488 174.375 72.5488C173.198 72.5488 172.246 71.5972 172.246 70.4202C172.246 69.2432 173.198 68.2916 174.375 68.2916C175.552 68.2916 176.503 69.2432 176.503 70.4202Z",
    fill: "#909090"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M287.566 156.615C287.566 157.792 286.615 158.744 285.438 158.744C284.261 158.744 283.309 157.792 283.309 156.615C283.309 155.438 284.261 154.487 285.438 154.487C286.615 154.487 287.566 155.438 287.566 156.615Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7802_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 251,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvrSafetyAirbags4);
export default __webpack_public_path__ + "static/media/rvr-safety-airbags-4.966b9c104ac3769f668aa6184061d23f.svg";
export { ForwardRef as ReactComponent };